module.exports = __webpack_public_path__ + "img/checo.01f14dc4.jpg";